import _toConsumableArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext } from 'react';
import { useMediaQuery, Container, Grid, TAGTypography, TAGCarousel, useTheme, FacilityContext } from '../..';
import Card from './Card';

var PromotionsAndOffering = function PromotionsAndOffering(_ref) {
  var backgroundColor = _ref.backgroundColor,
      branding = _ref.branding,
      cards = _ref.cards,
      sectionTitle = _ref.sectionTitle;

  var _useContext = useContext(FacilityContext),
      facilityState = _useContext.state;

  var mobileWidth = useMediaQuery('(max-width:600px)');
  var tabletWidth = useMediaQuery('(max-width:900px)');
  var theme = useTheme();
  var facilityPromotions = facilityState.promotions ? facilityState.promotions.reduce(function (promotions, promotion) {
    if (promotions[promotion.slot].priority < promotion.priority) {
      promotions[promotion.slot] = _objectSpread({}, promotion);
    }

    return promotions;
  }, _toConsumableArray(cards)) : cards;
  return React.createElement(Grid, {
    sx: mobileWidth ? {
      backgroundColor: "backgrounds.".concat(backgroundColor),
      padding: '40px 0'
    } : {
      padding: '40px 0'
    }
  }, mobileWidth && sectionTitle && React.createElement(Container, null, React.createElement(Grid, {
    container: true,
    direction: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    sx: {
      marginBottom: '20px'
    }
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    color: backgroundColor === 'dark' ? 'text.light' : 'text.primary',
    variant: "h1"
  }, sectionTitle)))), React.createElement(Container, {
    sx: _defineProperty({}, theme.breakpoints.down('sm'), {
      paddingLeft: '0',
      paddingRight: '0'
    })
  }, React.createElement(Grid, {
    container: true,
    sx: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, !tabletWidth ? React.createElement(Grid, {
    container: true,
    columnSpacing: 3,
    direction: "row",
    wrap: "nowrap",
    justifyContent: "center"
  }, facilityPromotions.map(function (promotion) {
    return React.createElement(Grid, {
      item: true,
      xs: 4,
      key: promotion.name
    }, React.createElement(Card, {
      card: promotion,
      branding: branding,
      roundedImage: true,
      allCards: cards,
      eyebrowColor: "success.dark",
      eyebrowVariant: "overline",
      eyebrowTextTransform: "uppercase"
    }));
  })) : React.createElement(TAGCarousel, {
    peeking: tabletWidth,
    sx: {
      minWidth: {
        sm: '100%',
        xs: '100%',
        md: '100%',
        lg: '100%'
      },
      mb: '32px',
      flex: 1,
      flexBasis: '100%'
    }
  }, facilityPromotions.map(function (promotion) {
    return React.createElement(Card, {
      key: promotion.name,
      allCards: cards,
      branding: branding,
      card: promotion,
      roundedImage: true,
      eyebrowColor: "success.dark",
      eyebrowTextTransform: "uppercase"
    });
  })))));
};

export default PromotionsAndOffering;